const Security = () =>
  import(
    /* webpackChunkName: "system-setting-security" */ '@/pages/system/setting/security.vue'
  )

export default {
  path: 'security',
  meta: {
    label: 'security',
    auth: 'security'
  },
  component: {
    name: 'Security',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemSettingSecurity',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Security
    }
  ]
}
